export default __webpack_public_path__ + "lora-cloud.0f77fe255ed86553dc3f.png";